// First Way My Own Way
// import React, { useState } from 'react'

// export default function About() {
//     const handleDarkMode = () => {
//         setBgColor(!bgColor);
//     }
//     const handleBtnToggle = () => {
//         setBtnName(!btnName);
//     }
//     const [bgColor, setBgColor] = useState(false);
//     const [btnName, setBtnName] = useState(false);
//     // let myStyle = {
//     //     backgroundColor: bgColor ? "black" : "white", 
//     //     color: bgColor ? "white" : "black"}
//     // }
//     return (
//         <div className='container' style={{ backgroundColor: bgColor ? "black" : "white", color: bgColor ? "white" : "black", border: bgColor ? "1px solid white" : "none"}}>
//             <h1 className='my-3'>About Us</h1>
//             <div className="accordion" id="accordionExample">
//                 <div className="accordion-item">
//                     <h2 className="accordion-header">
//                         <button className="accordion-button" style={{ backgroundColor: bgColor ? "black" : "white", color: bgColor ? "white" : "black", border: bgColor ? "1px solid white" : "none"}} type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
//                             Accordion Item #1
//                         </button>
//                     </h2>
//                     <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
//                         <div className="accordion-body" style={{ backgroundColor: bgColor ? "black" : "white", color: bgColor ? "white" : "black", border: bgColor ? "1px solid white" : "none"}}>
//                             <strong>This is the first item's accordion body.</strong> It is shown by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
//                         </div>
//                     </div>
//                 </div>
//                 <div className="accordion-item">
//                     <h2 className="accordion-header">
//                         <button className="accordion-button collapsed" style={{ backgroundColor: bgColor ? "black" : "white", color: bgColor ? "white" : "black", border: bgColor ? "1px solid white" : "none"}} type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
//                             Accordion Item #2
//                         </button>
//                     </h2>
//                     <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
//                         <div className="accordion-body" style={{ backgroundColor: bgColor ? "black" : "white", color: bgColor ? "white" : "black", border: bgColor ? "1px solid white" : "none"}}>
//                             <strong>This is the second item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
//                         </div>
//                     </div>
//                 </div>
//                 <div className="accordion-item">
//                     <h2 className="accordion-header">
//                         <button className="accordion-button collapsed" style={{ backgroundColor: bgColor ? "black" : "white", color: bgColor ? "white" : "black", border: bgColor ? "1px solid white" : "none"}} type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
//                             Accordion Item #3
//                         </button>
//                     </h2>
//                     <div id="collapseThree" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
//                         <div className="accordion-body" style={{ backgroundColor: bgColor ? "black" : "white", color: bgColor ? "white" : "black", border: bgColor ? "1px solid white" : "none"}}>
//                             <strong>This is the third item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             <div className='container my-3'>
//                 <button type="button" className="btn btn-primary" onClick={() => {handleDarkMode(); handleBtnToggle();}}>{btnName ? "Disable Dark Mode" : "Enable Dark Mode"}</button>
//             </div>
//             <br />
//         </div>
//     )
// }






// Second Way According to Code With Harry

import React, { useState } from 'react'

export default function About() {
    const [myStyle, setMyStyle] = useState({
        color: "black",
        backgroundColor: "white"
    });
    const [btnName, setBtnName] = useState("Enable Dark Mode");
    const handleToggleStyle = () => {
        if (myStyle.color === "black") {
            setMyStyle({
                color: "white",
                backgroundColor: "#212529",
                border: "1px solid white"
            });
            setBtnName("Disable Dark Mode");
        }
        else {
            setMyStyle({
                color: "black",
                backgroundColor: "white"
            });
            setBtnName("Enable Dark Mode");
        }
    }
    return (
        <div className='container' style={myStyle}>
            <div className='container my-3'>
                <div className='row align-items-center'>
                    <div className='col'>
                        <h1>About Us</h1>
                    </div>
                    <div className='col-auto'>
                        <div className="form-check form-switch">
                            <input
                                className='form-check-input mx-2'
                                type="checkbox"
                                role="switch"
                                id='flexSwitchCheckDefault'
                                checked={myStyle.color === 'white'}
                                onChange={handleToggleStyle}
                            />
                            <label className="form-check-label" htmlFor="flexSwitchCheckDefault">
                                {btnName}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div className="accordion" id="accordionExample">
                <div className="accordion-item">
                    <h2 className="accordion-header">
                        <button className="accordion-button" style={myStyle} type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                            <strong>TextUtils: Transforming Text with Ease.</strong>
                        </button>
                    </h2>
                    <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                        <div className="accordion-body" style={myStyle}>

                            <strong>TextUtils</strong> is a versatile and user-friendly web application designed to enhance your text editing experience. With a range of powerful features, <strong>TextUtils</strong> allows you to transform your text effortlessly. Whether you need to convert text to uppercase, apply formatting styles, remove extra spaces, or reverse the words, <strong>TextUtils</strong> has got you covered. Our goal is to provide you with a seamless and efficient text editing tool that simplifies your work and boosts productivity. Try <strong>TextUtils</strong> today and unlock the potential of your text!
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header">
                        <button className="accordion-button collapsed" style={myStyle} type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                            <strong>Free To Use</strong>
                        </button>
                    </h2>
                    <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                        <div className="accordion-body" style={myStyle}>
                            At <strong>TextUtils</strong>, we believe in providing accessible tools to everyone. That's why our app is completely free to use. Whether you're a student, professional, or casual user, you can enjoy all the features and benefits of <strong>TextUtils</strong> without any charges. We believe in empowering users with powerful text manipulation capabilities, without burdening them with costs. Experience the freedom and convenience of <strong>TextUtils</strong>, and make your text stand out, without spending a dime.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header">
                        <button className="accordion-button collapsed" style={myStyle} type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                            <strong>Browser Compatibility</strong>
                        </button>
                    </h2>
                    <div id="collapseThree" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                        <div className="accordion-body" style={myStyle}>
                            <strong>TextUtils</strong> is designed to work seamlessly across a wide range of browsers. We understand that each user has their preferred browser, and we strive to ensure that <strong>TextUtils</strong> delivers an exceptional experience, regardless of the browser you choose. Whether you use Chrome, Firefox, Safari, or any other popular browser, <strong>TextUtils</strong> guarantees smooth performance and compatibility. Say goodbye to browser limitations and enjoy the power of <strong>TextUtils</strong>, no matter where you work or browse.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header">
                        <button className="accordion-button collapsed" style={myStyle} type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseThree">
                            <strong>Boost Productivity</strong>
                        </button>
                    </h2>
                    <div id="collapseFour" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                        <div className="accordion-body" style={myStyle}>
                            <strong>TextUtils</strong> is designed to boost your productivity and streamline your text editing workflow. With a wide range of features at your fingertips, you can quickly convert text to uppercase or lowercase, apply formatting styles like bold, italic, underline, or strike through, and even reverse letters or words. Say goodbye to manual text editing tasks and let <strong>TextUtils</strong> do the heavy lifting. Save time and effort with <strong>TextUtils</strong>, allowing you to focus on what matters most.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header">
                        <button className="accordion-button collapsed" style={myStyle} type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseThree">
                            <strong>Accessibility and Ease of Use</strong>
                        </button>
                    </h2>
                    <div id="collapseFive" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                        <div className="accordion-body" style={myStyle}>
                            At <strong>TextUtils</strong>, accessibility and ease of use are our top priorities. Our user-friendly interface allows both beginners and experienced users to navigate and utilize the app effortlessly. No technical expertise is required to harness the power of <strong>TextUtils</strong>. We have carefully designed the app to be intuitive and straightforward, ensuring that you can start editing text without any hassle. Experience the simplicity and accessibility of <strong>TextUtils</strong> today.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header">
                        <button className="accordion-button collapsed" style={myStyle} type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseThree">
                            <strong>Meet the Creator</strong>
                        </button>
                    </h2>
                    <div id="collapseSix" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                        <div className="accordion-body" style={myStyle}>
                            <div className='row align-items-center'>
                                <div className='col'>
                                    <img src={process.env.PUBLIC_URL + '/images/pranav3.jpg'} alt="Pranav Arya" width="300" height="400" />
                                </div>
                                <div className='col'>
                                    <strong>TextUtils</strong> is the brainchild of <strong>Pranav Arya</strong>, a passionate developer dedicated to creating innovative solutions for text manipulation. With expertise in web development and a deep understanding of user needs, <strong>Pranav Arya</strong> envisioned <strong>TextUtils</strong> as a powerful tool to simplify and enhance the text editing experience. Through meticulous design and coding, <strong>Pranav Arya</strong> has brought <strong>TextUtils</strong> to life, empowering users with a comprehensive suite of text manipulation features. Join <strong>Pranav Arya</strong> on this exciting journey and unlock the true potential of your text with <strong>TextUtils</strong>.
                                    <br />
                                    <br />
                                    <strong>LinkedIn:</strong> <a href="https://www.linkedin.com/in/pranavarya37/" target='_blank' rel="noopener noreferrer">@pranavarya37</a>
                                    <br />
                                    <strong>Instagram:</strong> <a href="https://www.instagram.com/pranavarya37" target='_blank' rel="noopener noreferrer">@pranavarya37</a>
                                    <br />
                                    <strong>Twitter:</strong> <a href="https://www.twitter.com/pranavarya37" target='_blank' rel="noopener noreferrer">@pranavarya37</a>
                                    <br />
                                    <strong>Github:</strong> <a href="https://www.github.com/pranavarya37" target='_blank' rel="noopener noreferrer">@pranavarya37</a>
                                    <br />
                                    <strong>Email:</strong> <a href="mailto:pranavarya2799@gmail.com">pranavarya2799@gmail.com</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='container my-3'>
                <button type="button" className="btn btn-primary" onClick={handleToggleStyle}>{btnName}</button>
            </div>
            <br />
        </div>
    )
}
